module.exports = __webpack_public_path__ + "static/img/pikachu.cb846d8.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/construction/pikachu.gif
// module id = 9fS0
// module chunks = 0